var vertical_embed_viewer_default = {
  "card": "ST5RL",
  "slimLayout": "Kdpv9",
  "cardLayout": "vZDUQ",
  "imageContainer": "dyA6W",
  "image": "QPVQF",
  "content": "_7sEWN"
};
export {
  vertical_embed_viewer_default as default
};
//# sourceMappingURL=vertical-embed-viewer-scss.js.map
